// extracted by mini-css-extract-plugin
module.exports = {"action-ico":"report-btn_action-ico__DTHoI","action-btn":"report-btn_action-btn__rf_eb","active":"report-btn_active__9q_93"};